import { MutationTree } from 'vuex';
import {
  FETCH_TOLL_DOMAIN_INFO_BY_ID,
  FETCH_TOLL_DOMAINS,
  FETCH_TOTAL_TOLL_DOMAINS,
  FETCH_RULE_BY_ID,
  FETCH_VARIANTS,
  TollDomainState,
  UPDATE_NAVIGATION,
  REINIT,
  TOLL_DOMAIN_NAVIGATION,
  USER_SELECTION_REGISTER_DOMAIN,
  USER_SELECTION_RESET_ACTIONS,
  TRIGGER_DOMAIN_USER_SELECTION_ACTION,
  USER_SELECTION_CLEAR_DOMAINS,
  UPDATE_DOMAINS_STATE,
  SET_ERROR,
  IDomainsStatePayload
} from './types';

const mutations: MutationTree<TollDomainState> = {
  [REINIT](state: TollDomainState) {
    state.navigation.start = 0;
    state.userSelection.domains = [];
  },
  [TOLL_DOMAIN_NAVIGATION](state: TollDomainState, { direction }) {
    const incrementValues: any = {
      forward: state.navigation.domainsPerPage,
      backward: state.navigation.domainsPerPage * -1
    };
    state.navigation.start += incrementValues[direction];
  },
  [USER_SELECTION_REGISTER_DOMAIN](state: TollDomainState, domainId: string) {
    const userSelectionDevices = state.userSelection.domains;
    if (!userSelectionDevices.includes(domainId)) {
      state.userSelection.domains.push(domainId);
    } else {
      state.userSelection.domains = userSelectionDevices.filter(e => e !== domainId);
    }
  },
  [USER_SELECTION_RESET_ACTIONS](state: TollDomainState) {
    Object.keys(state.userSelection.actions).forEach((e) => {
      state.userSelection.actions[e].enabled = false;
    });
  },
  [TRIGGER_DOMAIN_USER_SELECTION_ACTION](state: TollDomainState, action: string) {
    if (Object.keys(state.userSelection.actions).includes(action)) {
      state.userSelection.actions[action].enabled = true;
    }
  },
  [USER_SELECTION_CLEAR_DOMAINS](state: TollDomainState) {
    state.userSelection.domains = [];
  },
  [UPDATE_DOMAINS_STATE](
    state: TollDomainState,
    stateToUpdate: IDomainsStatePayload
  ) {
    const {
      view,
      stateKey,
      stateValue
    } = stateToUpdate;

    state.tollDomainsState[stateKey][view] = stateValue;
  },
  [FETCH_TOLL_DOMAIN_INFO_BY_ID](state: TollDomainState, payload) {
    state.domainInfo = payload;
  },
  [FETCH_TOLL_DOMAINS](state: TollDomainState, payload: { masterId: number, name: string, type: string, modifiedAt: number, modifiedBy: string, rules: any, ruleConfigNames: {id: number, name: string}[] }[]) {
    state.domains = payload;
  },
  [FETCH_TOTAL_TOLL_DOMAINS](state: TollDomainState, payload) {
    state.total = payload;
  },
  [FETCH_RULE_BY_ID](state: TollDomainState, payload) {
    state.rule = payload;
  },
  [FETCH_VARIANTS](state: TollDomainState, payload) {
    state.variants = payload;
  },
  [UPDATE_NAVIGATION](state: TollDomainState, payload) {
    state.navigation = payload;
  },
  [SET_ERROR](state: TollDomainState, payload) {
    state.errorMessage = payload;
  }
};

export default mutations;
